// AUTO-GENERATED by overlay_implementer.py — DO NOT HAND-EDIT.
// composition: monster-energy-full
// items: 73
// generated from productions.overlay_design_spec at 2026-05-28T20:07:35

import React from "react";
import { AbsoluteFill } from "remotion";
import { PaletteProvider, BigStat, BrandChips, Chapter, ComparisonChain, EndCard, EquationStack, HookText, LowerThird, Stamp, Tag, TextHighlight } from "./overlayKit";
import { MONSTERENERGYFULL_PALETTE } from "./MonsterEnergyFullPalette";

export const MonsterEnergyFull: React.FC = () => (
  <PaletteProvider value={MONSTERENERGYFULL_PALETTE}>
    <AbsoluteFill>
      <BigStat sub="MONSTER · ANNUAL" endS={29.13} outS={31.6} color="neutral" label="CANS A YEAR" value={11.5} suffix=" B" valueS={27.88} decimals={1} />
      <BigStat sub="ANNUALLY" endS={33.46} outS={35.5} color="neutral" label="CASES SHIPPED" value={958} suffix=" M" valueS={32.26} />
      <BigStat sub="CANS PER HOUR" endS={39.84} outS={41.8} color="primary" label="PRODUCTION LINE" value={130000} suffix=" / HR" valueS={38.88} />
      <BigStat sub="TOTAL PROCESS" endS={45.17} outS={47.0} color="primary" label="RAW → SEALED PALLET" value={45} suffix=" MIN" valueS={44.63} />
      <Chapter num="01" sub="& FORMULA STAGING" numS={55.11} outS={57.8} title="INGREDIENT RELEASE" titleS={55.65} />
      <Stamp atS={60.95} sub="EVERY INGREDIENT · EVERY RUN" outS={62.6} color="primary" title="CERTIFICATE OF ANALYSIS" />
      <BrandChips outS={70.1} brands={[{"atS": 63.83, "name": "CAFFEINE"}, {"atS": 64.55, "name": "TAURINE"}, {"atS": 65.14, "name": "B-VITAMINS"}, {"atS": 66.1, "name": "SUCRALOSE"}, {"atS": 67.05, "name": "GLUCOSE"}]} />
      <TextHighlight hi="ENTIRE BATCH REJECTED" hiS={87.38} pre="OFF-SPEC SHIPMENT →" outS={90.0} post="" hiColor="secondary" />
      <Stamp atS={91.14} sub="PREVENTIVE CONTROLS" outS={95.5} color="secondary" title="FDA 21 CFR 117" />
      <TextHighlight hi="PHARMACEUTICAL-GRADE" hiS={101.74} pre="THE CAFFEINE IS" outS={104.8} post="" hiColor="primary" />
      <BigStat sub="OVER" endS={118.17} outS={120.6} color="neutral" label="SHIPPED TO" value={140} suffix=" COUNTRIES" valueS={117.55} />
      <LowerThird sub="THE HEART OF THE LINE" name="KRONES CONTIFLOW" outS={133.6} subS={130.88} nameS={129.64} />
      <Tag inS={133.4} outS={137.3} label="SYRUP THROUGHPUT" sub="15–90 M³ / HOUR" color="primary" />
      <Chapter num="02" sub="& DEAERATION" numS={138.48} outS={141.12} title="WATER TREATMENT" titleS={139.01} />
      <TextHighlight hi="REVERSE OSMOSIS" hiS={152.06} pre="FILTERED BY" outS={155.0} post="+ UV" hiColor="primary" />
      <TextHighlight hi="DEAERATION" hiS={160.13} pre="THE STEP MOST SKIP:" outS={162.8} post="" hiColor="primary" />
      <BigStat sub="LESS THAN" endS={175.51} outS={177.5} color="primary" label="VACUUM PRESSURE" value={50} suffix=" MBAR" valueS={175.21} />
      <BigStat sub="DOWN TO" endS={181.43} outS={183.5} color="primary" label="RESIDUAL OXYGEN" value={0.5} suffix=" MG/L" valueS={180.73} decimals={1} />
      <Chapter num="03" sub="& SWEETENER DISSOLUTION" numS={188.1} outS={190.81} title="SYRUP BATCHING" titleS={188.69} />
      <Tag inS={196.0} outS={199.0} label="SUGAR DISSOLVED AT" sub="35–40 °C" color="secondary" />
      <BigStat sub="MONITORED LIVE" endS={209.97} outS={211.7} color="primary" label="SUGAR PRECISION" value={0.05} prefix="±" suffix=" °BRIX" valueS={208.89} decimals={2} />
      <TextHighlight hi="INDUSTRIAL PRECISION" hiS={212.32} pre="THAT'S" outS={214.8} post="" hiColor="neutral" />
      <TextHighlight hi="TO THE MICROGRAM" hiS={232.36} pre="B6 & B12 DOSED" outS={234.8} post="" hiColor="primary" />
      <Chapter num="04" sub="& HIGH-PRESSURE CARBONATION" numS={243.69} outS={246.37} title="FINAL BLENDING" titleS={244.26} />
      <Tag inS={248.4} outS={252.0} label="BLEND RATIO" sub="SYRUP : WATER = 1 : 4" color="primary" />
      <BigStat sub="≈ 4× A CAR TIRE" endS={256.96} outS={261.2} color="primary" label="CARBONATION" value={8} suffix=" BAR" valueS={256.79} />
      <BigStat sub="KRONES CONTIFLOW" endS={265.88} outS={267.5} color="primary" label="CO₂ ACCURACY" value={0.05} prefix="±" suffix=" VOL" valueS={264.62} decimals={2} />
      <Tag inS={269.4} outS={272.0} label="BLEND HELD AT" sub="2–3 °C" color="primary" />
      <TextHighlight hi="HENRY'S LAW" hiS={273.06} pre="GET IT WARM →" outS={275.6} post="GAS BLOWS OFF" hiColor="secondary" />
      <Stamp atS={285.92} sub="IT GETS FAST FROM HERE" outS={289.5} color="primary" title="SUBSCRIBE" />
      <Chapter num="05" sub="" numS={291.3} outS={293.92} title="COUNTER-PRESSURE FILLING" titleS={291.89} />
      <LowerThird sub="CAN FILLING SYSTEM" name="SIDEL EVOFILL" outS={299.5} subS={296.93} nameS={296.02} />
      <BigStat sub="CANS PER HOUR" endS={299.86} outS={301.0} color="primary" label="FILLING SPEED" value={130000} suffix=" / HR" valueS={298.63} />
      <BigStat sub="CANS EVERY SECOND" endS={302.0} outS={303.9} color="primary" label="THAT IS" value={36} suffix=" / SEC" valueS={301.5} />
      <BigStat sub="COUNTER-PRESSURE" endS={309.53} outS={311.0} color="primary" label="FILL PRESSURE" value={2.5} suffix=" BAR" valueS={308.8} decimals={1} />
      <BigStat sub="EVERY CAN, EVERY TIME" endS={316.29} outS={318.8} color="neutral" label="FILL DEVIATION" value={1} suffix=" ML" valueS={316.14} />
      <TextHighlight hi="X-RAY CHECKED" hiS={320.89} pre="EVERY SINGLE CAN" outS={323.5} post="" hiColor="primary" />
      <TextHighlight hi="ALREADY PRINTED" hiS={331.64} pre="CANS ARRIVE" outS={334.3} post="" hiColor="primary" />
      <TextHighlight hi="FOOD-GRADE EPOXY" hiS={345.61} pre="LINED WITH" outS={348.3} post="" hiColor="primary" />
      <Chapter num="06" sub="& THERMAL STABILIZATION" numS={360.87} outS={363.56} title="DOUBLE SEAMING" titleS={361.49} />
      <TextHighlight hi="A MECHANICAL INTERLOCK" hiS={372.84} pre="NOT A CRIMP —" outS={375.5} post="" hiColor="neutral" />
      <BigStat sub="EVERY" endS={383.8} outS={386.0} color="primary" label="EXTERNAL SEAM CHECK" value={30} suffix=" MIN" valueS={383.57} />
      <BigStat sub="EVERY" endS={387.08} outS={389.3} color="secondary" label="FULL TEARDOWN" value={4} suffix=" HRS" valueS={386.88} />
      <Tag inS={405.0} outS={407.9} label="TUNNEL PASTEURIZER" sub="HEAT-SEALED SAFETY" color="secondary" />
      <BigStat sub="8–10 MINUTES" endS={408.75} outS={410.8} color="secondary" label="PASTEURIZE" value={80} suffix=" °C" valueS={408.57} />
      <BigStat sub="≈ 25 PASTEURIZATION UNITS" endS={411.96} outS={414.5} color="primary" label="PASTEURIZER PRESSURE" value={13.5} suffix=" BAR" valueS={411.06} decimals={1} />
      <TextHighlight hi="VITAMINS SURVIVE" hiS={419.4} pre="MICROBES DIE —" outS={422.0} post="" hiColor="primary" />
      <Chapter num="07" sub="& PACKAGING" numS={423.52} outS={426.21} title="INSPECTION, CODING" titleS={424.11} />
      <LowerThird sub="HIGH-SPEED INSPECTION" name="KRONES CHECKMAT" outS={432.8} subS={430.48} nameS={429.49} />
      <BigStat sub="TOTAL ELAPSED" endS={463.74} outS={465.7} color="primary" label="RAW → WRAPPED PALLET" value={45} suffix=" MIN" valueS={463.26} />
      <BigStat sub="MODERN FACILITY" endS={468.46} outS={470.0} color="primary" label="CO-PACKER AUTOMATION" value={85} suffix=" %" valueS={467.66} />
      <TextHighlight hi="A HUMAN TASTES IT" hiS={471.69} pre="THE ONLY MANUAL STEP" outS={474.5} post="" hiColor="neutral" />
      <HookText atS={478.6} outS={481.5} text="WHAT THE LABEL WON'T TELL YOU" />
      <BigStat sub="= 13.5 TEASPOONS" endS={485.07} outS={488.2} color="secondary" label="SUGAR PER CAN" value={54} suffix=" G" valueS={484.36} />
      <EquationStack l1="ONE CAN" l2="A FULL DAY'S SUGAR" op=">" l1S={491.99} l2S={495.55} opS={493.18} outS={497.3} opColor="secondary" />
      <ComparisonChain {...({
        "frames": [
                {
                        "landAt": 493.9,
                        "layout": "center",
                        "equivalents": []
                },
                {
                        "landAt": 496.7,
                        "layout": "left-half",
                        "equivalents": [
                                {
                                        "atS": 496.7,
                                        "outS": 500.0,
                                        "color": "secondary",
                                        "label": "A VENTI COFFEE",
                                        "value": "MORE"
                                }
                        ],
                        "slideDurationS": 0.6
                }
        ],
        "constant": {
                "color": "primary",
                "count": {
                        "to": 160,
                        "atS": 494.14,
                        "endS": 494.94,
                        "from": 0
                },
                "label": "MONSTER",
                "suffix": " mg",
                "fadeInS": 493.9,
                "fadeInDurS": 0.35
        },
        "eqSignColor": "secondary"
})} />
      <Tag inS={508.4} outS={511.2} label="TAURINE" sub="IS IT DANGEROUS?" color="secondary" />
      <BrandChips outS={516.75} brands={[{"atS": 512.0, "name": "MEAT"}, {"atS": 512.48, "name": "FISH"}, {"atS": 513.45, "name": "BREAST MILK"}]} />
      <TextHighlight hi="CHEMICALLY IDENTICAL" hiS={522.15} pre="SYNTHETIC IS" outS={524.6} post="" hiColor="primary" />
      <Stamp atS={524.92} sub="150 MG/L → WARNING LABEL" outS={531.5} color="secondary" title="EU REGULATION" />
      <BigStat sub="PER SERVING" endS={534.48} outS={536.0} color="secondary" label="HEALTH CANADA CAP" value={180} suffix=" MG" valueS={533.82} />
      <Tag inS={537.7} outS={540.7} label="AUSTRALIA / NEW ZEALAND" sub="145–320 MG/L · FSANZ 2.6.4" color="secondary" />
      <BigStat sub="UNDER EVERY CEILING — BY DESIGN" endS={545.24} outS={549.5} color="primary" label="MONSTER ORIGINAL" value={160} suffix=" MG" valueS={544.73} />
      <BigStat sub="2026" endS={555.76} outS={557.9} color="neutral" label="ENERGY DRINK MARKET" value={83} prefix="$" suffix=" B" valueS={555.26} />
      <BigStat sub="BY 2034" endS={559.72} outS={561.3} color="primary" label="PROJECTED" value={157} prefix="$" suffix=" B" valueS={558.97} />
      <BigStat sub="SHIPPED LAST YEAR" endS={563.27} outS={564.9} color="neutral" label="MONSTER CANS" value={11.5} suffix=" B" valueS={562.46} decimals={1} />
      <BigStat sub="AS OF FEB 2026" endS={566.78} outS={570.2} color="secondary" label="COCA-COLA STAKE" value={20.9} suffix=" %" valueS={566.08} decimals={1} />
      <TextHighlight hi="AN INDUSTRIAL MACHINE" hiS={572.62} pre="NOT A NICHE PRODUCT —" outS={575.5} post="" hiColor="neutral" />
      <BigStat sub="" endS={579.25} outS={580.9} color="primary" label="MARKET GROWTH" value={8} suffix=" % / YR" valueS={579.14} />
      <BigStat sub="VACUUM-DEAERATED" endS={590.67} outS={592.1} color="primary" label="OXYGEN" value={0.5} suffix=" MG/L" valueS={589.87} decimals={1} />
      <BigStat sub="MEASURED LIVE" endS={594.19} outS={595.8} color="primary" label="SUGAR" value={0.05} prefix="±" suffix=" °BRIX" valueS={593.33} decimals={2} />
      <BigStat sub="IN 45 MINUTES FLAT" endS={610.77} outS={612.8} color="neutral" label="CANS A YEAR" value={11.5} suffix=" B" valueS={609.83} decimals={1} />
      <EndCard atS={618.99} outS={625.8} />
    </AbsoluteFill>
  </PaletteProvider>
);

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
